import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  OnboardingFooterContainerStyles,
  PageStyles,
  ScreenVideoStyles,
  TitleStyles,
} from './MediaScreen.styles.ts';

interface MediaScreenProps {
  title: string;
  videoSrc: string;
  videoAlt: string;
  buttonText: string;
  screenName: string;
}

export const MediaScreen: React.FC<MediaScreenProps> = ({
  title,
  videoSrc,
  videoAlt,
  buttonText,
  screenName,
}) => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: screenName,
      });
    }
  }, [screenName]);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="dark-solid">
      <IonContent>
        <TitleStyles>{title}</TitleStyles>
        <ScreenVideoStyles
          src={videoSrc}
          autoPlay
          muted
          playsInline
          aria-label={videoAlt}
        />
        <OnboardingFooterContainerStyles>
          <OnboardingFooter
            onContinue={handleNextStep}
            buttonText={buttonText}
          />
        </OnboardingFooterContainerStyles>
      </IonContent>
    </PageStyles>
  );
};
